import { render, staticRenderFns } from "./PurchasePod.vue?vue&type=template&id=72dc37c6&scoped=true&"
import script from "./PurchasePod.vue?vue&type=script&lang=js&"
export * from "./PurchasePod.vue?vue&type=script&lang=js&"
import style0 from "./PurchasePod.vue?vue&type=style&index=0&id=72dc37c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72dc37c6",
  null
  
)

/* custom blocks */
import block0 from "@/locales/purchase_pod.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fvar%2Fjenkins%2Fworkspace%2Fon-production-deploy%2Ffront%2Fcomponents%2FProductPage%2FPurchasePod%2FPurchasePod.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports